import { QUANTITY } from '@Apis/constants';

const ListScreenKeys = ({ documentData, MONEY, priceMasking }) => {
  const record = documentData;

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  return [
    {
      label: 'Available Stock (Primary)',
      value: `${QUANTITY(record?.department_quantity || 0, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`,
    },
    {
      label: 'Available Stock (Secondary)',
      value: `${QUANTITY(record?.secondary_available_qty || '0', record?.secondary_uom_info?.precision || 0)} ${record?.secondary_uom_info?.uqc?.toProperCase() || 'N/A'}`,
    },
    {
      label: 'Bad Stock in Default Department',
      value: `${QUANTITY(record?.store_rejected_stock || '0', record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`,
    },
    {
      label: 'HSN Code',
      value: record?.product_info?.hsn_code,
    },
    {
      label: 'UOM',
      value: record?.uom_info?.uqc,
    },
    {
      label: 'Purchase UOM',
      value: record?.purchase_uom_info?.uqc,
    },
    {
      label: 'Taxes',
      value: `${record?.tax_value}%`,
    },
    {
      label: 'Cost Price',
      value: MONEY(record?.cost_price),
      dataMasking: isDataMaskingPolicyEnable && isHideCostPrice,
    },
    {
      label: 'Weighted Avg Price',
      value: MONEY(record?.avg_batch_cost_price),
      dataMasking: isDataMaskingPolicyEnable && isHideCostPrice,
    },
    {
      label: 'Weighted Avg Landing',
      value: MONEY(record?.avg_batch_landed_cost),
      dataMasking: isDataMaskingPolicyEnable && isHideSellingPrice,
    },
    {
      label: 'Selling Price',
      value: MONEY(record?.selling_price),
      dataMasking: isDataMaskingPolicyEnable && isHideSellingPrice,
    },
    {
      label: 'MRP',
      value: MONEY(record?.mrp),
    },
    {
      label: 'Minimum Threshold',
      value: record?.threshold_qty,
    },
    {
      label: 'Marketplace Product',
      value: record?.is_marketplace_product ? 'Yes' : 'No',
    },
    {
      label: 'Sales Enabled Product',
      value: record?.is_sales_product ? 'Yes' : 'No',
    },
    {
      label: 'Purchase Enabled Product',
      value: record?.is_purchase_product ? 'Yes' : 'No',
    },
    {
      label: 'Qc Rules',
      value: record?.qc_id ? record?.qcr_number : '-',
    },
    {
      label: 'Projected Incoming Qty',
      value: record?.qc_id ? record?.projected_incoming_stock_qty : '-',
    },
    {
      label: 'Projected Outgoing Qty',
      value: record?.qc_id ? record?.projected_outgoing_stock_qty : '-',
    },
    {
      label: 'Pending In Qc Qty',
      value: record?.qc_id ? record?.pending_in_qc_qty : '-',
    },
  ];
};

export { ListScreenKeys };
